import { render } from "./RenderingAListOfData.vue?vue&type=template&id=07b33c12"
import script from "./RenderingAListOfData.vue?vue&type=script&lang=js"
export * from "./RenderingAListOfData.vue?vue&type=script&lang=js"

import "./RenderingAListOfData.vue?vue&type=style&index=0&id=07b33c12&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__